import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Notification } from '@ynap/notification';
import { AsyncButton, Button } from '@ynap/button';
import { AsyncSelect } from '@ynap/select';
import BEMHelper from '@ynap/bem-helper';
import ReactMarkdown from 'markdown-to-jsx';
import ViewportObserver from '@ynap/viewport-observer';
import { withOptimizely } from '@ynap/optimizely-utils';

const bem = new BEMHelper('CTAButtons');

// TODO: The logic for shopping bag Update button should be done in the same way as addToWishlist and addToBag in the future
// TODO: Async State handling Button will be made in https://jira.nap/browse/ISP-1499
class CTAButtons extends PureComponent {
    constructor(props) {
        super(props);

        this.buttonsRef = React.createRef();

        this.state = {
            wishlistLoading: false,
            sticky: props.stickyCTAButton,
            scrollY: 0,
            isLoggedSFModal: false,
            isUserLogged: false,
        };

        this.renderCartButton = this.renderCartButton.bind(this);
        this.renderWishlistButton = this.renderWishlistButton.bind(this);
        this.renderViewMoreButton = this.renderViewMoreButton.bind(this);
        this.openShippingRestrictionsModal = this.openShippingRestrictionsModal.bind(this);
        this.renderMessage = this.renderMessage.bind(this);
        this.setScrollY = this.setScrollY.bind(this);
    }

    setScrollY(scroll) {
        this.setState({
            scrollY: scroll,
        });
    }

    componentDidMount() {
        if (this.props.stickyCTAButton) {
            this.setScrollY(window.scrollY);
        }

        window?.SF?.getUserSummary().then((res) => {
            this.setState({ isUserLogged: res });
        });
    }

    componentDidUpdate(prevProps) {
        const { wishlist: prevWishlist, errors: prevErrors } = prevProps;
        const { wishlist, errors } = this.props;
        //Handled null wishlist for apps who don't show add to wishlist button
        if (!wishlist) {
            return;
        }
        const { addToWishlistLoading: prevAddToWishlistLoading, fetchWishlistsLoading: prevFetchWishlistsLoading } = prevWishlist;
        const { addToWishlistLoading, fetchWishlistsLoading } = wishlist;

        /*
        combine loading states of fetchWishlists and addToWishlist - used for async button
        So dot animation shows for both fetchWishlists and addToWishlist
        */
        if (!prevFetchWishlistsLoading && fetchWishlistsLoading) {
            this.setState({ wishlistLoading: true });
        }
        if (prevAddToWishlistLoading && !addToWishlistLoading) {
            this.setState({ wishlistLoading: false });
        }
        if (!prevErrors.fetchWishlists && errors.fetchWishlists) {
            this.setState({ wishlistLoading: false });
        }
    }

    renderWishlistButton() {
        const {
            messages,
            wishlist,
            cart,
            skuPartNumber,
            closeModal,
            errors,
            multipleWishlistsFeatureToggle = true,
            numberOfDisplayWishlist,
            locale,
            urlConfig,
            selectedProductVariant,
            setNoSizeNotification,
            preventSkuNotification,
            errorNotificationTimer,
            optimizely,
            disableAddToWishlistSecondaryAction,
            inLine,
        } = this.props;

        const { addToWishlistOnLoad, buyable } = selectedProductVariant;

        const { addToWishlist, addToWishlistLoading, wishlists, goToWishlist, wishlistId, failedAddToWishlist, fetchWishlists, fetchWishlistsLoading } =
            wishlist;

        const addToCartLoading = !!(cart && cart.addToCartLoading);
        const error = errors.addToWishlist || errors.fetchWishlists;
        const proceedAction = skuPartNumber ? true : null;
        const notificationmessage = skuPartNumber ? '' : 'NO_SIZE_SELECTED_ERROR';

        const wishlistPreviouslyFetched = this.state.wishlistLoading;
        const doFetchWishlists = multipleWishlistsFeatureToggle && wishlists?.length === 0;

        const masterCategory = selectedProductVariant?.masterCategory;

        //TODO: remove multiple wishlist feature toggle verification after Colleague Launch
        if (wishlists && wishlists.length > 1 && multipleWishlistsFeatureToggle) {
            const options = wishlists.map((wishlist) => ({ key: wishlist.id, value: wishlist.id, label: wishlist.name }));

            if (this.state.isLoggedSFModal) {
                this.setState({ isLoggedSFModal: false, wishlistLoading: false });
            }

            let asyncState = {
                loading: addToWishlistLoading || fetchWishlistsLoading || (!error && this.state.wishlistLoading) || addToWishlistLoading,
                primaryAction: {
                    message: messages.ctaButtons.addToWishlist(),
                    click: () => {
                        addToWishlist(skuPartNumber, wishlistId, {}, addToWishlistLoading || addToCartLoading);
                        optimizely?.track?.('add_to_wishlist_clicks');
                        optimizely?.track('plp_pdp_atw');
                        optimizely?.track?.('hp_carousel_add_to_wishlist');
                        /* istanbul ignore next */
                        if (optimizely?.user?.attributes?.clicks_Intelistyle) {
                            optimizely.track('ATW_Intelistyle');
                        }
                        /* istanbul ignore next */
                        optimizely?.track?.('addtobag_addtowishlist');
                        optimizely?.track?.('hp_carousel_add_to_bag_add_to_wishlist');

                        const categories = masterCategory
                            ?.map((category) => category?.labelEN)
                            ?.toString()
                            ?.toLowerCase();
                        if (categories?.includes?.('shoes')) {
                            optimizely?.track?.('shoespdp_atw');
                        }
                    },
                },
                ...(!disableAddToWishlistSecondaryAction && {
                    secondaryAction: {
                        message: messages.ctaButtons.goToWishlist(),
                        timeout: 5000,
                    },
                }),
                trackError: () => failedAddToWishlist(),
                error: error,
            };

            /* TODO: move to window.matchMedia util when created */
            const isMobileOrTablet = window !== 'undefined' && window?.matchMedia?.('(min-width: 0px) and (max-width: 1023px)')?.matches;
            const extraProps = wishlistPreviouslyFetched && {
                mobilePrompt: messages.ctaButtons?.selectWishlist(),
                openOnMount: !isMobileOrTablet,
            };

            return (
                <Fragment>
                    <AsyncSelect
                        numOfListElementsDisplayed={numberOfDisplayWishlist ? numberOfDisplayWishlist : undefined}
                        value=""
                        type="secondary"
                        wishlist={wishlist}
                        asyncState={asyncState}
                        messages={messages}
                        numberOfDisplayWishlist={numberOfDisplayWishlist}
                        skuPartNumber={skuPartNumber}
                        cart={cart}
                        errors={errors}
                        options={options}
                        closeModal={closeModal}
                        locale={locale}
                        disabled={addToCartLoading}
                        urlConfig={urlConfig}
                        proceedaction={proceedAction}
                        notificationmessage={notificationmessage}
                        notificationPosition={'top'}
                        arrowPosition={'bottom'}
                        setNoSizeNotification={setNoSizeNotification}
                        errorNotificationTimer={errorNotificationTimer}
                        optimizely={optimizely}
                        {...(extraProps || {})}
                    />
                </Fragment>
            );
        } else {
            const primaryWishlistID = wishlists && wishlists.length ? wishlists[0].id : undefined;

            // This validation is used when the user is logged via login modal and has only one wishlist
            // It will wait for setTimeout at (state/wishlist-state/src/actions/fetchNavigation) to trigger
            // It will auto add the product to the  wishlist after the modal closes
            if (this.state.isLoggedSFModal && wishlists && wishlists.length === 1) {
                addToWishlist(skuPartNumber, primaryWishlistID, {}, addToWishlistLoading || addToCartLoading);
                this.setState({ isLoggedSFModal: false, wishlistLoading: false });
            }

            let asyncState = {
                loading: fetchWishlistsLoading || (!error && this.state.wishlistLoading) || addToWishlistLoading || (!error && this.state.isLoggedSFModal),
                primaryAction: {
                    message: messages.ctaButtons.addToWishlist(),
                    click: async () => {
                        if (doFetchWishlists) {
                            this.setState({ isLoggedSFModal: !this.state.isUserLogged ? true : false });
                            const response = await fetchWishlists({}, skuPartNumber);
                            if (response?.json?.GiftList?.length === 1) {
                                const id = response.json.GiftList[0]?.uniqueID || undefined;
                                addToWishlist(skuPartNumber, id, {}, addToWishlistLoading || addToCartLoading);
                                optimizely?.track?.('add_to_wishlist_clicks');
                                optimizely?.track?.('hp_carousel_add_to_wishlist');
                                /* istanbul ignore next */
                                if (optimizely?.user?.attributes?.clicks_Intelistyle) {
                                    optimizely.track('ATW_Intelistyle');
                                }
                                optimizely?.track?.('addtobag_addtowishlist');
                                optimizely?.track?.('hp_carousel_add_to_bag_add_to_wishlist');

                                const categories = masterCategory
                                    ?.map((category) => category.labelEN)
                                    ?.toString()
                                    ?.toLowerCase();
                                if (categories?.includes?.('shoes')) {
                                    optimizely?.track?.('shoespdp_atw');
                                }
                            } else {
                                this.setState({ wishlistLoading: false });
                            }
                        } else {
                            addToWishlist(skuPartNumber, primaryWishlistID, {}, addToWishlistLoading || addToCartLoading);
                            optimizely?.track?.('add_to_wishlist_clicks');
                            optimizely?.track?.('hp_carousel_add_to_wishlist');
                            /* istanbul ignore next */
                            if (optimizely?.user?.attributes?.clicks_Intelistyle) {
                                optimizely.track('ATW_Intelistyle');
                            }
                            optimizely?.track?.('addtobag_addtowishlist');
                            optimizely?.track?.('hp_carousel_add_to_bag_add_to_wishlist');

                            const categories = masterCategory
                                ?.map((category) => category.labelEN)
                                ?.toString()
                                ?.toLowerCase();
                            if (categories?.includes?.('shoes')) {
                                optimizely?.track?.('shoespdp_atw');
                            }
                        }
                    },
                },
                ...(!disableAddToWishlistSecondaryAction && {
                    secondaryAction: {
                        message: messages.ctaButtons.goToWishlist(),
                        click: () => (wishlistId && wishlistId === primaryWishlistID ? closeModal() : goToWishlist(urlConfig, primaryWishlistID, locale)),
                        timeout: 5000,
                    },
                }),
                trackError: () => failedAddToWishlist(),
                error: error,
            };

            return (
                <Fragment>
                    <AsyncButton
                        messages={messages}
                        proceedaction={proceedAction}
                        notificationmessage={notificationmessage}
                        asyncState={asyncState}
                        type="secondary"
                        className={{
                            wrapperClassName: bem('wrapperAddToWishlist', { inLine: inLine && buyable?.canAddToBag }),
                            buttonClassName: bem('addToWishlist', { inLine }),
                            notificationClassName: bem('buttonNotification'),
                        }}
                        disabled={addToCartLoading}
                        triggerClickOnMount={addToWishlistOnLoad}
                        buttonGroup={'CTAButtons'}
                        setNoSizeNotification={setNoSizeNotification}
                        preventSkuNotification={preventSkuNotification}
                        errorNotificationTimer={errorNotificationTimer}
                    />
                </Fragment>
            );
        }
    }

    renderViewMoreButton(isFullWidth = false) {
        const { messages, setReducedMode, reducedMode } = this.props;

        return (
            <div className={bem('wrapperViewMore', { fullWidth: isFullWidth, reducedMode })}>
                <Button onClick={() => setReducedMode(false)} type="secondary" className={bem('viewMore')}>
                    {messages.ctaButtons.viewMoreDetails()}
                </Button>
            </div>
        );
    }

    renderCartButton() {
        const {
            messages,
            cart,
            wishlist,
            skuPartNumber,
            locale,
            errors,
            disableAddToBag,
            setNoSizeNotification,
            preventSkuNotification,
            selectedProductVariant,
            errorNotificationTimer,
            scrollToSizeSelect,
            includeCartWithAddToBag = true,
            optimizely,
            disableAddToBagSecondaryAction = false,
            category,
            reducedMode,
            setSizeModalOpen,
            sizeSkuModal,
        } = this.props;
        const { addToCartLoading, addToCart, failedAddToBag, goToCart } = cart;
        const preOrder = selectedProductVariant.preOrder;
        const masterCategory = selectedProductVariant?.masterCategory;
        const addToWishlistLoading = wishlist && wishlist.addToWishlistLoading;
        const fetchWishlistsLoading = wishlist && wishlist.fetchWishlistsLoading;
        const cartError = errors.addToCart;
        const error = cartError?.error || cartError?.body?.error;

        const asyncState = {
            loading: addToCartLoading,
            primaryAction: {
                message: preOrder ? messages.ctaButtons.preOrder() : messages.ctaButtons.addToBag(),
                click: () => {
                    reducedMode && setSizeModalOpen(true);
                    this.state.sticky && scrollToSizeSelect?.();
                    addToCart(skuPartNumber, {
                        setActionNotificationOnError: false,
                        addToCartLoading: addToWishlistLoading || addToCartLoading,
                        includeShoppingCart: includeCartWithAddToBag,
                    });
                    optimizely?.track?.('add_to_bag_clicks');
                    optimizely?.track?.('hp_carousel_add_to_bag');
                    optimizely?.track?.('pdp_add_to_bag_clicks');
                    /* istanbul ignore next */
                    if (optimizely?.user?.attributes?.clicks_intelistyle) {
                        optimizely.track(`ATB_clicks_Intelistyle`);
                        if (['Dresses', 'Tops', 'Trousers'].includes(category)) {
                            optimizely?.track?.(`ATB_PDP_${category}`);
                        }
                    }
                    optimizely?.track?.('addtobag_addtowishlist');
                    optimizely?.track?.('hp_carousel_add_to_bag_add_to_wishlist');

                    const categories = masterCategory
                        ?.map((category) => category?.labelEN)
                        ?.toString()
                        ?.toLowerCase();
                    if (categories?.includes('shoes')) {
                        optimizely?.track?.('shoespdp_atb');
                    }
                },
            },
            ...(!disableAddToBagSecondaryAction && {
                secondaryAction: {
                    message: messages.ctaButtons.viewShoppingBag(),
                    click: () => goToCart(locale),
                    timeout: 5000,
                },
            }),
            trackError: () => failedAddToBag(),
            error: error && error.errorKey,
        };

        const proceedAction = !!skuPartNumber;
        const notificationmessage = skuPartNumber ? '' : 'NO_SIZE_SELECTED_ERROR';

        return (
            <Fragment>
                <AsyncButton
                    messages={messages}
                    sizeSkuModal={sizeSkuModal}
                    proceedaction={proceedAction}
                    notificationmessage={notificationmessage}
                    asyncState={asyncState}
                    type={preOrder ? 'secondary' : 'primary'}
                    className={{
                        wrapperClassName: bem('wrapperAddToBag', { stickyCta: this.state.sticky }),
                        buttonClassName: bem(
                            'addToBag',
                            {
                                stickyCta: this.state.sticky,
                                preOrder,
                                disabled: disableAddToBag,
                            },
                            { preOrder },
                        ),
                        stackButtonClassName: bem('stackButtons', { stickyCta: this.state.sticky }),
                        notificationClassName: bem('buttonNotification', { stickyCta: this.state.sticky }),
                    }}
                    disabled={fetchWishlistsLoading || this.state.wishlistLoading || addToWishlistLoading || disableAddToBag}
                    buttonGroup={'CTAButtons'}
                    setNoSizeNotification={setNoSizeNotification}
                    preventSkuNotification={preventSkuNotification}
                    errorNotificationTimer={errorNotificationTimer}
                    displayLoading={disableAddToBagSecondaryAction}
                    reducedMode={reducedMode}
                />
            </Fragment>
        );
    }

    openShippingRestrictionsModal(e) {
        e.preventDefault();
        const { setModal } = this.props;
        setModal('shippingRestrictions');
    }

    openCountrySelectionModal(e) {
        e.preventDefault();
        window.SF.triggerChangeCountryFlow();
    }

    renderMessage(notification, modifier, reducedMode) {
        if (!notification?.message) return;
        let onClick = () => {};

        if (notification?.type === 'shippingRestricted') {
            onClick = this.openShippingRestrictionsModal;
        }

        if (notification?.type === 'countryShippingRestricted') {
            // If there's a productUrl we want to enable the product link instead of country selection modal
            onClick = !notification.productUrl ? this.openCountrySelectionModal : () => {};
        }

        return (
            <Notification
                type="info"
                className={bem('notification', { ...modifier, reducedMode })}
                message={
                    <ReactMarkdown
                        options={{
                            wrapper: React.Fragment,
                            forceWrapper: true,
                            overrides: {
                                a: (props) => (
                                    <a href={props.href} onClick={onClick} target="_blank" rel="noopener noreferrer">
                                        {props.children}
                                    </a>
                                ),
                            },
                        }}
                    >
                        {notification?.message}
                    </ReactMarkdown>
                }
            />
        );
    }

    render() {
        const {
            loading,
            cart,
            wishlist,
            className,
            isProductSizeDisplayable,
            modifier,
            features,
            messages,
            setUser,
            selectedProduct,
            trackEmailUsCTA,
            trackCallUsCTA,
            stickyCTAButton,
            showCallUsCTA,
            fjwThresholdHandler,
            mrpHandler,
            napHandler,
            reducedMode,
        } = this.props;

        const EmailUsCTAFeature = features?.emailUsCTA?.Component;
        const CallUsCTAFeature = showCallUsCTA && features?.callUsCTA?.Component;
        if (loading) {
            return <div className={bem(null, 'loading', className)} />;
        }

        // TODO: change selectedProductVariant to just product
        const { selectedProductVariant = {} } = this.props;

        const { buyable } = selectedProductVariant;
        const isMobileOrTablet = typeof window !== 'undefined' && window?.matchMedia?.('(min-width: 0px) and (max-width: 1023px)')?.matches;

        return (
            <div ref={this.buttonsRef} className={bem(null, null, className)}>
                <div className={bem('buttonsWrapper')}>
                    {!reducedMode && buyable.canAddToWishlist && isProductSizeDisplayable && cart && this.renderCartButton()}
                    {stickyCTAButton && isMobileOrTablet && (
                        <>
                            <div
                                className={bem('placeholder', {
                                    sticky: this.state.sticky,
                                })}
                            ></div>
                            {!reducedMode && (
                                <ViewportObserver keepObserving={true}>
                                    {(intersected) => {
                                        this.setState({
                                            sticky: !intersected && this.buttonsRef.current?.getBoundingClientRect().top > 0,
                                        });
                                    }}
                                </ViewportObserver>
                            )}
                        </>
                    )}
                    {!reducedMode && buyable.canAddToWishlist && isProductSizeDisplayable && wishlist && this.renderWishlistButton()}
                    {reducedMode && this.renderViewMoreButton(!(buyable.canAddToBag && isProductSizeDisplayable && cart))}
                </div>
                {this.renderMessage(buyable.notification, modifier, reducedMode)}
                {EmailUsCTAFeature && (
                    <EmailUsCTAFeature
                        messages={messages}
                        selectedProduct={selectedProduct}
                        setUser={setUser}
                        tracking={trackEmailUsCTA}
                        trackingCallUs={trackCallUsCTA}
                        fjwThresholdHandler={fjwThresholdHandler}
                        mrpHandler={mrpHandler}
                        napHandler={napHandler}
                    />
                )}
                {CallUsCTAFeature && (
                    <CallUsCTAFeature messages={messages} selectedProduct={selectedProduct} setUser={setUser} trackingCallUs={trackCallUsCTA} />
                )}
            </div>
        );
    }
}

CTAButtons.propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    isProductSizeDisplayable: PropTypes.bool,
    messages: PropTypes.shape({
        notifications: PropTypes.shape({
            errors: PropTypes.shape({
                ERR_SKU_ALREADY_EXISTS: PropTypes.func,
                ERR_WISH_LIST_NOT_EXISTS: PropTypes.func,
                ERR_WISH_LIST_MAX_WISH_LIST_ITEMS_REACHED: PropTypes.func,
            }),
        }),
        ctaButtons: PropTypes.shape({
            addToBag: PropTypes.func.isRequired,
            addToBagLoading: PropTypes.func.isRequired,
            addToWishlistLoading: PropTypes.func.isRequired,
            addToWishlist: PropTypes.func.isRequired,
            goToWishlist: PropTypes.func.isRequired,
            viewShoppingBag: PropTypes.func.isRequired,
        }).isRequired,
    }),
    cart: PropTypes.shape({
        addToCartLoading: PropTypes.bool.isRequired,
        addToCart: PropTypes.func.isRequired,
        goToCart: PropTypes.func.isRequired,
        failedAddToBag: PropTypes.func.isRequired,
    }),
    wishlist: PropTypes.shape({
        addToWishlistLoading: PropTypes.bool.isRequired,
        addToWishlist: PropTypes.func.isRequired,
        goToWishlist: PropTypes.func.isRequired,
        wishlists: PropTypes.array,
        wishlistId: PropTypes.string,
        failedAddToWishlist: PropTypes.func.isRequired,
        id: PropTypes.string,
        name: PropTypes.string,
        fetchWishlists: PropTypes.func,
        fetchWishlistsLoading: PropTypes.bool,
    }),
    skuPartNumber: PropTypes.string.isRequired,
    selectedProductVariant: PropTypes.shape({
        name: PropTypes.string,
        buyable: PropTypes.boolean,
        notification: PropTypes.string,
        addToWishlistOnLoad: PropTypes.bool,
        preOrder: PropTypes.bool,
    }).isRequired,
    closeModal: PropTypes.func,
    errors: PropTypes.shape({
        addToCart: PropTypes.string,
        addToWishlist: PropTypes.string,
        fetchWishlists: PropTypes.string,
    }),
    multipleWishlistsFeatureToggle: PropTypes.bool,
    numberOfDisplayWishlist: PropTypes.number,
    urlConfig: PropTypes.object,
    setModal: PropTypes.func.isRequired,
    modifier: PropTypes.string,
    setNoSizeNotification: PropTypes.func,
    includeCartWithAddToBag: PropTypes.bool,
    trackEmailUsCTA: PropTypes.func,
    trackCallUsCTA: PropTypes.func,
    stickyCTAButton: PropTypes.bool,
    scrollToSizeSelect: PropTypes.func,
    features: PropTypes.shape({
        callUsCTA: PropTypes.shape({
            Component: PropTypes.func,
        }),
        emailUsCTA: PropTypes.shape({
            Component: PropTypes.func,
        }),
    }),
    setUser: PropTypes.func,
    selectedProduct: PropTypes.object,
    optimizely: PropTypes.PropTypes.shape({
        track: PropTypes.func.isRequired,
    }),
    showCallUsCTA: PropTypes.bool,
    disableAddToBag: PropTypes.bool,
    preventSkuNotification: PropTypes.bool,
    errorNotificationTimer: PropTypes.bool,
    disableAddToBagSecondaryAction: PropTypes.bool,
    reducedMode: PropTypes.bool,
    setReducedMode: PropTypes.func,
};

export default withOptimizely(CTAButtons);
